import {
    CREATE_TUTORIAL,
    RETRIEVE_TUTORIALS,
    UPDATE_TUTORIAL,
    DELETE_TUTORIAL,
    DELETE_ALL_TUTORIALS,
} from '../ActionTypes/ActionTypes';


const initialState = {
    countries: []
};
function TutorialReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case CREATE_TUTORIAL:           
            return {
                ...state,
                countries: payload,
            };
            
        case RETRIEVE_TUTORIALS:
            return {
                ...state,
                countries: payload,
            };

        //case UPDATE_TUTORIAL:
        //    return tutorials.map((tutorial) => {
        //        if (tutorial.id === payload.id) {
        //            return {
        //                ...tutorial,
        //                ...payload,
        //            };
        //        } else {
        //            return tutorial;
        //        }
        //    });

        //case DELETE_TUTORIAL:
        //    return tutorials.filter(({ id }) => id !== payload.id);

        case DELETE_ALL_TUTORIALS:
            return [];

        default:
            return [];
    }
};

export default TutorialReducer;